export default __webpack_public_path__ + "static/media/single_matrix.b2a1b4be.svg";